import { Navigate } from 'react-router-dom';

import { authorized, authorizedLoader, isAdminUser } from '../../../utils/loaders.ts';
import { filesTabLoader } from './loaders.ts';
import {
    ADMIN_SPACE_SETTINGS_EMAILS_PATH,
    ADMIN_SPACE_SETTINGS_FILES_PATH,
    ADMIN_SPACE_SETTINGS_PATH,
    ADMIN_SPACE_SETTINGS_USERS_ADD_PATH,
    ADMIN_SPACE_SETTINGS_USERS_EDIT_PATH,
    ADMIN_SPACE_SETTINGS_USERS_PATH,
} from './paths.ts';

export default [
    {
        handle: {
            title: ['admin:spaceSettingsPage.documentTitle'],
        },
        path: ADMIN_SPACE_SETTINGS_PATH,
        lazy: async () => ({ Component: (await import('./pages/SpaceSettingsPage.tsx')).default }),
        loader: authorized(isAdminUser),
        children: [
            {
                index: true,
                element: <Navigate to={ADMIN_SPACE_SETTINGS_FILES_PATH} replace={true} />,
            },

            {
                handle: {
                    title: ['admin:spaceSettingsPage.filesTabDocumentTitle'],
                },
                path: ADMIN_SPACE_SETTINGS_FILES_PATH,
                lazy: async () => ({ Component: (await import('./tabs/FilesTab.tsx')).default }),
                loader: authorizedLoader(filesTabLoader, isAdminUser),
            },
            {
                handle: {
                    title: ['admin:spaceSettingsPage.usersTabDocumentTitle'],
                },
                path: ADMIN_SPACE_SETTINGS_USERS_PATH,
                lazy: async () => ({ Component: (await import('./tabs/UsersTab.tsx')).default }),
                children: [
                    {
                        handle: {
                            title: ['admin:spaceSettingsPage.addUserDocumentTitle'],
                        },
                        path: ADMIN_SPACE_SETTINGS_USERS_ADD_PATH,
                        lazy: async () => ({ Component: (await import('./tabs/UsersTab.tsx')).AddUserFormDialog }),
                    },
                    {
                        handle: {
                            title: ['admin:spaceSettingsPage.editUserDocumentTitle'],
                        },
                        path: ADMIN_SPACE_SETTINGS_USERS_EDIT_PATH,
                        lazy: async () => ({ Component: (await import('./tabs/UsersTab.tsx')).EditUserFormDialog }),
                    },
                ],
            },
            {
                handle: {
                    title: ['admin:spaceSettingsPage.emailsTabDocumentTitle'],
                },
                path: ADMIN_SPACE_SETTINGS_EMAILS_PATH,
                lazy: async () => ({ Component: (await import('./tabs/EmailsTab.tsx')).default }),
                // loader: authorizedLoader(filesTabLoader, isAdminUser),
            },
        ],
    },
];
